export enum LinksIdContainerArray {
    linkIds,
    quotedBodyLinkIds,
}
